import React from 'react';
import { TableHeader, TableRow, TableCell } from '../../../CommonComponents/OPL/Table/Table';
import { Text } from '../../../CommonComponents/OPL/Text/Text';

export const DataReconciliationTableHeader = () => {
  return (
    <TableHeader>
      <TableRow noBorder>
        <TableCell>
          <Text>Name</Text>
        </TableCell>
        <TableCell minWidth={200} flex="0 1 auto">
          <Text>Last Update</Text>
        </TableCell>
        <TableCell minWidth={160} flex="0 1 auto">
          <Text>Status</Text>
        </TableCell>
        <TableCell width={48} justifyContent="center" flex="0 1 auto" />
      </TableRow>
    </TableHeader>
  );
};
